import $ from 'jquery';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaOrderSimThankyou',
			dom: {
				banner: {
					modem: '.js-order-sim-thankyou-modem-price'
				}
			},
			classes: {
				banner: {
					modem: 'b-order-sim-thankyou_banner_modem'
				}
			}
		};

		this.options = $.extend(true, {}, defaults, options);
		this.modemPrice = false;
		this.$el = $(this.options.el);
		return this;
	}

	getDom() {
		this.$bannerModem = this.$el.find(this.options.dom.banner.modem);
		return this;
	}

	render() {
		if (this.$el.length) {
			if (yotaPortlets.region) {
				this.modemPrice = yotaPortlets.region.products.modem;
				this.getDom();
				if (this.modemPrice !== false && this.modemPrice !== true) {
					this.$bannerModem.text(this.modemPrice);
				} else {
					this.$el.removeClass(this.options.classes.banner.modem);
				}
			} else {
				console.error('The orderSimThankyou portlet has no data, set data to "yotaPortlets.region"');
			}
		}
		return this;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/order-sim-thankyou/order-sim-thankyou.js